/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum OptimizationExportHandlerFieldKeys {
    _ID = '_id',
    TYPE = 'type',
    REASON = 'reason',
    SOFTWARE_ACCOUNT_ID = 'software_account_id',
    SOFTWARE_ACCOUNT_EMAIL = 'software_account.email',
    SOFTWARE_ACCOUNT_NAME = 'software_account.name',
    ACCOUNT_ID = 'account_id',
    ACCOUNT_EMAIL = 'account.email',
    ACCOUNT_NAME = 'account.name',
    SOFTWARE_ID = 'software_id',
    SOFTWARE_DISPLAY_NAME = 'software.display_name',
    DATA_SOURCE_ID = 'data_source_id',
    DATA_SOURCE_NAME = 'data_source.name',
    YEARLY_SAVINGS = 'yearly_savings',
    EMPLOYEE_ID = 'employee_id',
    DATA_DUPLICATE_ACCOUNT_IDS = 'data.duplicate_account_ids',
    DATA_LAST_LOGIN_TIME = 'data.last_login_time',
    DATA_NEVER_LOGGED_IN = 'data.never_logged_in',
    DATA_SOFTWARE_LICENSES_ASSIGNED_IDS = 'data.software_licenses_assigned_ids',
    DATA_SOFTWARE_LICENSES_ASSIGNED_EXTERNAL_IDS = 'data.software_licenses_assigned_external_ids',
    DATA_SOFTWARE_LICENSES_ASSIGNED_NAMES = 'data.software_licenses_assigned_names',
    DATA_SOFTWARE_LICENSE_TO_ADD_IDS = 'data.software_license_to_add_ids',
    DATA_SOFTWARE_LICENSE_TO_ADD_EXTERNAL_IDS = 'data.software_license_to_add_external_ids',
    DATA_SOFTWARE_LICENSE_TO_ADD_NAMES = 'data.software_license_to_add_names',
    DATA_SOFTWARE_LICENSE_TO_REMOVE_IDS = 'data.software_license_to_remove_ids',
    DATA_SOFTWARE_LICENSE_TO_REMOVE_EXTERNAL_IDS = 'data.software_license_to_remove_external_ids',
    DATA_SOFTWARE_LICENSE_TO_REMOVE_NAMES = 'data.software_license_to_remove_names',
}
